import React, { useEffect, useState } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import "../PagesStyles/AdminMasters.css";
import { Icon } from "@iconify/react";
import {
  a104,
  a107,
  a125,
  a128,
  a138,
  a139,
  a163,
  a224,
  a225,
  a226,
  a30,
  a131,
  a95,
  a98,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
import GetApiService from "../../Api/getapiService";
import style from "./AddPacketNew.module.css";
import Customertable from "Components/support/customervendor/customer";
import { useRef } from "react";
import { Box } from "@mui/material";
import toast from "react-hot-toast";

export default function AddPacketNew() {
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);
    const [searchInput, setSearchInput] = useState('');


    const handleList = () => {
      // Custom logic for the List button
      console.log("List button clicked");
      setActive("List");
    };
    const handleSearchChange = (event) => {
      setSearchInput(event.target.value);
    };


    const handleSearchSubmit = () => {
      // You can handle the search logic here
      console.log("Searching for:", searchTerm);
    };
  

    


  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    CategoryId: "",
    ProductId: "",
    SKUId: "",
    PacketName: "",
    EmptyWeight: "",
    Description: "",
    CompanyId: "",
    BranchId: "",
    EmployeeId: "",
    Status: "",
    BoxName: "",
    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const [allCategoriesList, setAllCategoriesList] = useState([]);
  const [allBoxList, setAllBoxList] = useState([]);
  const [allProductsList, setAllProductsList] = useState([]);
  const [allSkuList, setAllSkuList] = useState([]);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const employeeId = adminLoggedIn.EmployeeId;
  const [collectionTypeData, setCollectionTypeData] = useState([]);
  const [collection, setCollection] = useState("");

  useEffect(() => {
    const formData = {
      ClientCode: clientCode,
    };
    fetch(a131, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => setCollectionTypeData(data));
  }, []);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a226, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchAllBox = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a30, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllBoxList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
    fetchAllBox();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Branch First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Departments First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Roles First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);

  const fetchAllCategoriesList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a125, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategoriesList(data);
      } else {
        // alert("Please Add Category First");
      }
    } catch (error) {
      console.log(error);
    }
  };


  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error("Submit button ref is not available");
        }
      }
    }
  };


    const inputRef1 = useRef(null);
      const inputRef2 = useRef(null);
      const inputRef3 = useRef(null);
      const inputRef4 = useRef(null);
      const inputRef5 = useRef(null);
      const inputRef6 = useRef(null);
      const inputRef7 = useRef(null);
      const inputRef8 = useRef(null);
      const inputRef9 = useRef(null);
      const inputRef10 = useRef(null);
      const inputRef11 = useRef(null);
      const inputRef12 = useRef(null);

  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
      inputRef12,
     
  ];


 
   

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };


  useEffect(() => {
    fetchAllCategoriesList();
  }, []);

  const fetchAllProductsList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a128, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllProductsList(data);
      } else {
        // alert("Please Add Product First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log('allProductsList', allProductsList);
  
  useEffect(() => {
    fetchAllProductsList();
  }, []);
  const fetchAllSkuList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a163, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllSkuList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllSkuList();
  }, []);

  // console.log(allCategories, "allCategories");
  // console.log(allCompaniesList, "allCompaniesList");
  // console.log(allDepartmentsList, "allDepartmentsList");
  // console.log(allBranchesList, "allBranchesList");
  // console.log(allRolesList, "allRolesList");
  // console.log(allCategoriesList, "allCategoriesList");

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    if (name == "SKUId") {
      if (value !== "") {
        const selectedSku = allSkuList.filter(
          (x) => x.Id == parseInt(value)
        )[0];
        setNewCategory({
          ...newCategory,
          [name]: parseInt(value),
          CategoryId: `${selectedSku.CategoryId}`,
          ProductId: selectedSku.ProductId,
        });
      } else {
        setNewCategory({
          ...newCategory,
          [name]: "",
          CategoryId: "",
          ProductId: "",
        });
      }
    } else {
      setNewCategory({ ...newCategory, [name]: value });
    }
  };
  console.log(newCategory, "newCategory");
  console.log(newCategory, "newCategory");

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ClientCode: clientCode,
      CategoryId: parseInt(newCategory.CategoryId),
      ProductId: parseInt(newCategory.ProductId),
      SKUId: newCategory.SKUId !== "" ? parseInt(newCategory.SKUId) : 0,
      PacketName: newCategory.PacketName,
      EmptyWeight: newCategory.EmptyWeight,
      Description: newCategory.Description,
      CompanyId: parseInt(newCategory.CompanyId),
      BranchId: parseInt(newCategory.BranchId),
      Status: newCategory.Status,
      BoxName: newCategory.BoxName ? newCategory.BoxName : null,
      EmployeeId: employeeId || 0,

      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    console.log(formData, "formData to send");
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a224 : a225,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      console.log(data);
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        CategoryId: "",
        ProductId: "",
        SKUId: "",
        PacketName: "",
        EmptyWeight: "",
        Description: "",
        CompanyId: "",
        BranchId: "",
        EmployeeId: "",
        Status: "",
        OldEntry: false,
      });
      if (data.Message) {
        // alert(data.Message);
        // setMessageType("error");
        toast.error(data.Message,{
          duration: 3000,
          position: 'top-center'
        });
        // setShowError(true);
        setActive("AddNew");
      } else {
        // setMessageType("success");
        toast.success("Packet Added Successfully",{
          duration: 3000,
          position: 'top-center'
        });
        // setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  const handleEditData = (data) => {
    console.log(data, "data");
    console.log(data, "data");
    console.log(data, "data");
    setNewCategory({ ...data, OldEntry: true });
    setActive("AddNew");
  };

  const filteredCollection = collectionTypeData.filter(
    (product) => product.ProductId == newCategory.ProductId
  );

  const columns = [
    { key: "serialNumber", label: "S.No", type: "read", priority: 2 },
    { key: "CategoryName", label: "Category Name", type: "read", priority: 1 },

    { key: "ProductName", label: "Product Name", type: "read", priority: 3 },
    { key: "PacketName", label: "Packet Name", type: "read", priority: 4 },
    { key: "BoxName", label: "Box", type: "read", priority: 5 },
    { key: "StockKeepingUnit", label: "SKU", type: "read", priority: 6 },

    {
      key: "EmptyWeight",
      label: "Empty Weight",
      type: "read",
      priority: 7,
    },
    { key: "Description", label: "Description", type: "read", priority: 8 },
    { key: "Status", label: "Status", type: "read", priority: 9 },
    
  ];

  const handlenew = () => {
    setActive("AddNew");
  };

  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Packet"}
          companyName={"Loyalstring"}
          module={"Product Masters"}
          page={"Packet"}
        />

        <div style={{ padding: "16px" }}>
          {active == "List" ? (
            <>
            <div className={style["white-space"]}>
               

               <div className={style["icon-div"]}>
                 <div className={style["search-container"]}>
                   <input
                     type="text"
                     value={searchInput}
                     onChange={handleSearchChange}
                     placeholder="Search..."
                     className={style["serach-input"]}
                   />
                   <button
                     style={{ margin: 0 }}
                     className={style["search-btn"]}
                     onClick={handleSearchSubmit}
                   >
                     <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                   </button>
                 </div>
                 
                 <Icon
                 
                   style={{
                     fontSize: "28px ",
                     color: "#0077d4",
                     cursor: "pointer",
                   }}
                   icon="bx:export"
                 />
                 
                
                 <button
                   // style={{ width: "30%" }}
                   className={style["custom-btn"]}
                 >
                   <Icon
                     style={{ fontSize: "24px " }}
                     icon="ic:outline-print"
                   />
                   Print
                 </button>
                 <button onClick={handlenew} style={{ margin: 0 }} className={style["custom-btn"]}>
                 New
                 <Icon icon="mdi:plus" width="24" height="24" />
               </button>
               </div>
             </div>

            <Customertable
              columns={columns}
              allCategories ={allCategories }
              handleEditData={handleEditData}
              searchInput={searchInput}
              setSearchInput={setSearchInput}

              // title={"All Customers"}
            />
            </>
           
          ) : (
           
            <div className={style.adminAddCategoryMainBox}>
              <div className={style.adminAddCategoryInnerBox}>
                <div className={style.adminCategoryAddCategoryMainBox}>
                  <form style={{width: '100%'}} onSubmit={addNewCategory}>

                    <div
                       style={{
                                           gridTemplateColumns: "repeat(4,2fr)",
                                           columnGap: "30px",
                                           margin: "0px 0px",
                                           padding: "var(--Space-0, 0px) 24px",
                                         }}
                      // className="adminCategoryAddCategoryInnerBox"
                    >
                        <Box sx={{ width: "95%", margin: "0 auto" }}>
                             <div
                                                   style={{
                                                     gridTemplateColumns: "repeat(4,1fr)",
                                                     columnGap: "40px",
                                                     margin: "15px 0px",
                                                   }}
                                                   className="adminCategoryAddCategoryInnerBox"
                                                 >
                      <label>
                        Company <sup>*</sup>
                      </label>
                      <select
                        name="CompanyId"
                        value={newCategory.CompanyId}
                        onChange={handleNewCategoryChange}
                        type="text"
                        required="required"
                        ref={inputRef1}
                        onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                      >
                        <option value={""}>Select an option</option>;
                        {allCompaniesList.map((x) => {
                          return (
                            <>
                              <option value={x.Id}>{x.CompName}</option>;
                            </>
                          );
                        })}
                      </select>{" "}
                      <label>
                        Branch <sup>*</sup>{" "}
                      </label>
                      <select
                        name="BranchId"
                        value={newCategory.BranchId}
                        onChange={handleNewCategoryChange}
                        type="text"
                        required="required"
                        ref={inputRef2}
                        onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                      >
                        <option value={""}>Select an option</option>;
                        {allBranchesList.map((x) => {
                          return (
                            <>
                              <option value={x.Id}>{x.BranchName}</option>;
                            </>
                          );
                        })}
                      </select>
                      <label>
                        Category <sup>*</sup>
                      </label>
                      <select
                        name="CategoryId"
                        value={newCategory.CategoryId}
                        onChange={handleNewCategoryChange}
                        type="text"
                        required="required"
                        ref={inputRef3}
                        onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                      >
                        <option value={""}>Select an option</option>;
                        {allCategoriesList.map((x) => {
                          return (
                            <>
                              <option value={x.Id}>{x.CategoryName}</option>;
                            </>
                          );
                        })}
                      </select>{" "}
                      <label>
                        Product<sup>*</sup>
                      </label>
                      <select
                        name="ProductId"
                        value={newCategory.ProductId}
                        onChange={handleNewCategoryChange}
                        type="text"
                        required="required"
                        ref={inputRef4}
                        onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                      >
                        <option value={""}>Select an option</option>;
                        {allProductsList
                          .filter((pro) => {
                            const matchesCategory =
                              newCategory.CategoryId === 0 ||
                              newCategory.CategoryId === "" ||
                              newCategory.CategoryId === null
                                ? true
                                : pro.CategoryId ===
                                  parseInt(newCategory.CategoryId);

                            return matchesCategory;
                          })
                          .map((x) => {
                            return (
                              <option value={x.Id}>{x.ProductName}</option>
                            );
                          })}
                      </select>{" "}
                      <label style={{ margin: 0 }}>Design</label>
                      <select
                        id="collection"
                        required="required"
                        value={collection}
                        onChange={(e) => setCollection(e.target.value)}
                        ref={inputRef5}
                        onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                      >
                        <option value="">Design</option>
                        {filteredCollection.map((x, y) => {
                          return (
                            <option
                              key={y}
                              value={`${parseInt(x.Id)},${x.DesignName}`}
                            >
                              {x.DesignName}
                            </option>
                          );
                        })}
                      </select>
                      <label>SKU</label>
                      <select
                        name="SKUId"
                        value={newCategory.SKUId}
                        onChange={handleNewCategoryChange}
                        type="text"
                        ref={inputRef6}
                        onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                      >
                        <option value={""}>Select an option</option>;
                        {/* {allSkuList.map((x) => {
                    return (
                        <>
                          <option value={x.Id}>{x.StockKeepingUnit}</option>
                          ;
                        </>
                    );
                  })} */}
                        {allSkuList
                          .filter((sku) => {
                            const matchesCategory =
                              !newCategory.CategoryId ||
                              sku.CategoryId ===
                                parseInt(newCategory.CategoryId); // Filter SKUs by selected category
                            const matchesProduct =
                              !newCategory.ProductId ||
                              sku.ProductId === parseInt(newCategory.ProductId); // Filter SKUs by selected product
                            const matchesDesign =
                              !collection ||
                              sku.DesignId ===
                                parseInt(collection.split(",")[0]) ||
                              0; // Filter SKUs by selected product
                            return (
                              matchesCategory && matchesProduct && matchesDesign
                            );
                          })
                          .map((x) => (
                            <option key={x.Id} value={x.Id}>
                              {x.StockKeepingUnit}
                            </option>
                          ))}
                      </select>
                      <label>
                        Packet Name<sup>*</sup>
                      </label>
                      <input
                        name="PacketName"
                        value={newCategory.PacketName}
                        onChange={handleNewCategoryChange}
                        type="text"
                        required="required"
                        className={style.AddCustomerInput}
                        style={{border: '1px solid #ddd'}}
                        ref={inputRef7}
                        onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                      />
                      <label>
                        Empty Weight<sup>*</sup>
                      </label>
                      <input
                        name="EmptyWeight"
                        value={newCategory.EmptyWeight}
                        onChange={handleNewCategoryChange}
                        type="number"
                        required="required"
                        className={style.AddCustomerInput}
                        style={{border: '1px solid #ddd'}}
                        ref={inputRef8}
                        onKeyDown={(e) => handleKeyPress(e, inputRef9)}
                      />
                      <label>Description</label>
                      <input
                        name="Description"
                        value={newCategory.Description}
                        onChange={handleNewCategoryChange}
                        type="text"
                        className={style.AddCustomerInput}
                        style={{border: '1px solid #ddd'}}
                        ref={inputRef9}
                        onKeyDown={(e) => handleKeyPress(e, inputRef10)}
                      />
                      <label htmlFor="Status">
                        Status <sup>*</sup>
                      </label>
                      <select
                        name="Status"
                        required="required"
                        value={newCategory.Status}
                        onChange={handleNewCategoryChange}
                        ref={inputRef10}
                        onKeyDown={(e) => handleKeyPress(e, inputRef11)}
                      >
                        <option value={""}>Select Status</option>
                        <option value={"Active"}>Active</option>
                        <option value={"InActive"}>InActive</option>
                      </select>
                      <label>Box</label>
                      <select
                        name="BoxName"
                        value={newCategory.BoxName}
                        onChange={handleNewCategoryChange}
                        type="text"
                        ref={inputRef11}
                        onKeyDown={(e) => handleKeyPress(e, inputRef12)}
                      >
                        <option value={""}>Select an option</option>;
                        {allBoxList.map((x) => {
                          return (
                            <>
                              <option value={x.Id}>{x.BoxName}</option>;
                            </>
                          );
                        })}
                      </select>{" "}
                      </div>
                      </Box>
                    </div>
                    {!loading ?
                    <div style={{padding: '10px 0px'}} className={style["btn-container"]}>
                    <button className={style.buttons} type="submit">
                      <Icon
                        icon="ic:baseline-check"
                        width="24"
                        height="24"
                      />{" "}
                      Submit
                    </button>
                    <button
                    
                      className={style.buttons}
                      style={{
                        backgroundColor: "#fff",
                        color: "#0077d4",
                        border: "1px solid #0077d4",
                      }}
                      type="button"
                      onClick={handleResetField}
                    >
                      <Icon
                        style={{ color: "#0077d4" }}
                        icon="ix:reset"
                        width="24"
                        height="24"
                      />
                      Reset
                    </button>
                    <button
                      className={style.buttons}
                      type="button"
                      onClick={handleList}
                    >
                      <Icon
                        icon="fluent:list-rtl-16-filled"
                        width="24"
                        height="24"
                      />
                      List
                    </button>
                  </div>
                     
                     : null}
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
